<template>
    <div class="pretlak">
        <div class="left">
            <div class="left_cont">
                <a href="/" class="back">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.25 7H14.75M6.5 1.75L1.25 7L6.5 1.75ZM1.25 7L6.5 12.25L1.25 7Z" stroke="#F93C34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Prejsť na hlavnú stránku DOFFERO®
                </a>
                <img class="tablet" src="/img/pretlak_left.svg" alt="pretlak">
                <img class="zlava" src="/img/pretlak_zlava.svg" alt="pretlak_zlava">
                <svg class="rect1" width="102" height="81" viewBox="0 0 102 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="102" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect2" width="55" height="81" viewBox="0 0 55 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.2" x="-135" width="190" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect3" width="102" height="81" viewBox="0 0 102 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect opacity="0.1" width="102" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
                <svg class="rect4" width="115" height="81" viewBox="0 0 115 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="115" height="81" rx="40.5" fill="#F93C34"/>
                </svg>
            </div>
        </div>
        <div class="right">
            <svg class="rect1" width="116" height="81" viewBox="0 0 116 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="232" height="81" rx="40.5" fill="#F93C34"/>
            </svg>
            <svg class="rect2" width="71" height="81" viewBox="0 0 71 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.1" width="178" height="81" rx="40.5" fill="#F93C34"/>
            </svg>
            <div class="right_cont">
                <div class="p_logo">
                    <a href="#">
                        <img src="/img/welcome/logos/doffero-logo-v2.svg" alt="logo">
                    </a>
                    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="16.3168" y1="0.771389" x2="1.77134" y2="15.3168" stroke="#263544" stroke-width="2.18182"/>
                        <line y1="-1.09091" x2="20.5704" y2="-1.09091" transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.45459 0)" stroke="#263544" stroke-width="2.18182"/>
                    </svg>
                    <a href="https://pretlak.sk/" target="_blank">
                        <svg width="130" height="29" viewBox="0 0 130 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8363 2.91569C12.2779 2.22038 10.3498 2.12999 8.05205 2.64452L0.593547 4.34804C0.41596 4.38661 0.262305 4.49604 0.168851 4.6505C0.0695108 4.80021 0.0377088 4.98417 0.081104 5.15808L3.74893 20.9139C3.84227 21.2713 4.20132 21.4942 4.56673 21.4215L9.63851 20.2638C9.99934 20.1713 10.2243 19.8157 10.151 19.4537L9.0664 14.7951L10.7898 14.3884C13.1063 13.8599 14.8097 12.9699 15.9001 11.7184C16.9905 10.4668 17.3099 8.86527 16.8583 6.91375C16.3997 4.94369 15.3924 3.61101 13.8363 2.91569Z" fill="#FF431D"/>
                            <path d="M33.711 11.1942C34.5153 10.6707 35.183 9.95946 35.6576 9.1205C36.1422 8.23833 36.3815 7.24029 36.3503 6.23202C36.3295 4.3157 35.6368 2.82367 34.2721 1.75593C32.9074 0.688197 31.0313 0.167152 28.6436 0.192797L21.2625 0.269729C21.0844 0.271667 20.9146 0.34605 20.7915 0.47605C20.6631 0.602615 20.5928 0.777515 20.5975 0.958628L20.7638 17.2229C20.7654 17.4035 20.8405 17.5755 20.9716 17.6985C21.0954 17.8283 21.2677 17.8994 21.4461 17.8943L26.3334 17.8419C26.7051 17.8269 26.9987 17.5181 26.9984 17.1425L26.9499 12.3342H27.9717L30.1676 17.118C30.2472 17.3021 30.3739 17.4614 30.5348 17.5796C30.735 17.7274 30.9799 17.8003 31.2275 17.7859L36.3399 17.7335C36.4858 17.7349 36.6255 17.6739 36.7244 17.5656C36.8286 17.4627 36.8862 17.3211 36.8837 17.174C36.879 17.0773 36.8529 16.9829 36.8075 16.8977L33.711 11.1942Z" fill="#FF431D"/>
                            <path d="M56.2181 5.25875L43.7863 1.63006C43.4232 1.53764 43.0508 1.74409 42.9407 2.09884L38.3231 17.5928C38.2288 17.9492 38.432 18.3165 38.7863 18.4297L51.418 22.114C51.5903 22.1672 51.7772 22.1471 51.9338 22.0584C52.0945 21.9757 52.2138 21.8313 52.2637 21.6591L53.2742 18.2769C53.325 18.1046 53.3035 17.9194 53.2146 17.763C53.1307 17.6043 52.9849 17.4863 52.811 17.4366L45.3478 15.2594L45.7969 13.7489L52.5338 15.7143C52.7073 15.7677 52.8953 15.7475 53.0532 15.6587C53.213 15.5751 53.332 15.4311 53.383 15.2594L54.3093 12.1342C54.3633 11.9626 54.3429 11.7765 54.2532 11.6203C54.1687 11.462 54.0231 11.3443 53.8497 11.2938L47.1127 9.32845L47.5618 7.81794L54.8321 9.9396C55.0044 9.99284 55.1913 9.97271 55.3479 9.88404C55.5086 9.80137 55.6279 9.65698 55.6778 9.48471L56.6883 6.10255C56.7332 5.9352 56.7105 5.75712 56.6251 5.606C56.5469 5.43721 56.3983 5.31047 56.2181 5.25875Z" fill="#FF431D"/>
                            <path d="M73.5563 10.8469L59.3215 6.94474C59.1484 6.89426 58.9624 6.91853 58.8077 7.01177C58.6491 7.09918 58.5329 7.24837 58.4862 7.42457L57.4377 11.3726C57.3523 11.7385 57.5659 12.1077 57.9235 12.2123L61.9532 13.3202L58.9301 24.5468C58.8811 24.722 58.9064 24.9099 59 25.0655C59.0866 25.2256 59.2343 25.3429 59.4089 25.3901L64.2633 26.7202C64.4364 26.7707 64.6224 26.7464 64.7771 26.6532C64.9356 26.5657 65.0518 26.4166 65.0986 26.2404L68.1217 15.0137L72.1513 16.118C72.5118 16.2073 72.8785 15.9966 72.9866 15.6382L74.0351 11.6901C74.084 11.515 74.0587 11.3271 73.9652 11.1715C73.8786 11.0114 73.7308 10.8941 73.5563 10.8469Z" fill="#FF431D"/>
                            <path d="M88.6701 22.9839C88.5454 22.8561 88.3738 22.7864 88.1964 22.7916L81.2816 22.9069L81.0915 11.1275C81.0899 10.9469 81.0149 10.775 80.884 10.652C80.7586 10.5233 80.5856 10.4536 80.4069 10.4597L75.4283 10.5401C75.2497 10.5418 75.0797 10.6176 74.9581 10.7499C74.8308 10.8768 74.7619 11.0518 74.7679 11.2324L75.0342 27.4942C75.0508 27.8681 75.3556 28.1624 75.7256 28.1621L88.269 27.9488C88.4475 27.9502 88.6183 27.8752 88.7392 27.7425C88.8665 27.6156 88.9354 27.4406 88.9294 27.26L88.8844 23.4594C88.881 23.2777 88.8034 23.1056 88.6701 22.9839Z" fill="#FF431D"/>
                            <path d="M110.472 23.2974L101.923 8.6124C101.809 8.40729 101.642 8.23635 101.439 8.11744C101.198 7.98435 100.916 7.94696 100.649 8.01287L95.2597 9.02719C94.984 9.06347 94.7327 9.20316 94.5575 9.41758C94.413 9.6012 94.322 9.8206 94.2942 10.052L91.7699 26.8283C91.7596 26.8871 91.7596 26.9473 91.7699 27.0061C91.8301 27.3035 92.1187 27.4986 92.4194 27.4453L97.0151 26.5774C97.454 26.544 97.8103 26.2119 97.8717 25.7791L98.1561 24.0363L103.489 23.0325L104.395 24.5452C104.612 24.9238 105.062 25.1043 105.483 24.9809L110.075 24.113C110.376 24.0533 110.573 23.7645 110.518 23.4647C110.511 23.407 110.495 23.3506 110.472 23.2974Z" fill="#FF431D"/>
                            <path d="M129.272 18.1909C129.249 18.0947 129.196 18.0083 129.121 17.9448L122.029 11.2638L124.265 2.6524C124.291 2.5581 124.291 2.45836 124.265 2.36406C124.227 2.22107 124.13 2.101 123.999 2.03353C123.872 1.96033 123.72 1.94255 123.579 1.9843L118.23 3.54202C117.822 3.62799 117.503 3.94809 117.418 4.3578L116.106 10.0894L114.706 5.27556C114.66 5.10035 114.542 4.95326 114.381 4.87118C114.226 4.77944 114.039 4.75653 113.867 4.80789L109.245 6.15463C108.89 6.26785 108.686 6.64017 108.779 7.00206L113.307 22.7094C113.355 22.8853 113.474 23.0331 113.636 23.1173C113.791 23.2082 113.978 23.2299 114.15 23.1771L118.772 21.8303C118.946 21.7839 119.093 21.6649 119.174 21.5033C119.264 21.3454 119.287 21.1578 119.237 20.9829L117.736 15.7788L122.215 20.2234C122.341 20.349 122.494 20.444 122.662 20.5011C122.89 20.5753 123.135 20.5753 123.362 20.5011L128.88 18.8942C129.022 18.855 129.141 18.7582 129.209 18.627C129.29 18.4972 129.313 18.3387 129.272 18.1909Z" fill="#FF431D"/>
                        </svg>
                    </a>
                </div>
                <a href="/" class="back">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.25 7H14.75M6.5 1.75L1.25 7L6.5 1.75ZM1.25 7L6.5 12.25L1.25 7Z" stroke="#F93C34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Prejsť na hlavnú stránku DOFFERO®
                </a>
                <h1>
                    Krásne cenové ponuky <br>
                    <span>so zľavou 15%</span>
                </h1>
                <p class="top_text">
                    <b>Vyklikaj si cenovú ponuku</b>, do ktorej sa klient 
                    zamiluje na prvý pohľad. Stačí jednoduchá
                    registrácia. V spolupráci s PRETLAKom sme pre teba 
                    pripravili zľavu a balík <b>PREMIUM ťa vyjde o takmer o 8 eur menej.</b>
                </p>
                <form class="form form--registration" action="/registracia" method="POST">
                    <input type="hidden" name="_token" :value="csrf">
                    <div class="form-group" :class="errors.meno ? 'has-error' : ''">
                        <div class="input-wrapper">
                            <label class="form__label" for="meno">Meno a priezvisko</label>
                            <input v-model="user.meno" class="form__input" type="text" name="meno" id="meno">
                        </div>
                        <div v-show="errors.meno" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.meno}}
                        </div>
                    </div>
                    <input type="hidden" name="priezvisko" :value="user.priezvisko">
                    <div class="form-group" :class="errors.email ? 'has-error' : ''">
                        <div class="input-wrapper email">
                            <label class="form__label" for="email">Email</label>
                            <input v-model="user.email" class="form__input" type="email" name="email" id="email">
                        </div>
                        <div v-show="errors.email" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.email}}
                        </div>
                    </div>
                    <div class="form-group form-group--last" :class="errors.password ? 'has-error' : ''">
                        <div class="input-wrapper password">
                            <label class="form__label" for="heslo">Heslo</label>
                            <input 
                                v-model="user.password" 
                                @focus="focus_password = true" 
                                @blur="focus_password = false"
                                class="form__input pass" type="password" name="password" id="heslo">
                            <div class="password-toggle js-password-show">
                                <i class="eye" data-target="#heslo"></i>
                            </div>
                        </div>
                        <div v-if="focus_password" class="password_errors">
                            <span :class="passowrd_errors.znaky ? 'active' : ''">
                                <svg v-if="!passowrd_errors.znaky" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.znaky" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                8 znakov
                            </span>
                            <span :class="passowrd_errors.letter ? 'active' : ''">
                                <svg v-if="!passowrd_errors.letter" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.letter" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                1 veľké písmeno
                            </span>
                            <span :class="passowrd_errors.number ? 'active' : ''">
                                <svg v-if="!passowrd_errors.number" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                                </svg>
                                <svg v-if="passowrd_errors.number" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="26" height="26" rx="13" fill="#34D399"/>
                                    <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                1 číslica
                            </span>
                        </div>
                        <div v-show="errors.password" class="form-error">
                            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                            </svg>
                            {{errors.password}}
                        </div>
                    </div>              
                    <div class="form-group">
                        <div class="input-wrapper email">
                            <label class="form__label is-jumped" for="email">Zľavový kod</label>
                            <input v-model="user.kod" class="form__input" type="text" name="kod" id="kod">
                        </div>
                    </div>  
                    <div class="form-helper">
                        <input v-model="user.suhlas" class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                        <p @click="user.suhlas = !user.suhlas">Súhlasím so 
                            <a target="_blank" href="https://www.doffero.com/DOFFERO_zmluva_registracia.pdf">
                            spracovaním osobných údajov</a>
                        </p>
                    </div>
                    <div v-show="errors.suhlas" class="form-error">
                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z" fill="#E83C58"/>
                        </svg>
                        {{errors.suhlas}}
                    </div>
                    <div class="form-submit">
                        <button @click="save($event)" class="btn--primary" type="submit" >Vytvoriť účet</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
    export default {
        props: ['email'],
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                user: {
                    meno: null,
                    priezvisko: null,
                    email: null,
                    password: null,
                    password_conf: null,
                    suhlas: false,
                    kod: "PRETLAK2021"
                },
                errors: {
                    meno: '',
                    email: '',
                    password: '',
                    password_conf: '',
                    suhlas: ''
                },
                focus_password: false,
                passowrd_errors: {
                    znaky: false,
                    number: false,
                    letter: false
                },
                emails: []
            }
        },
        created () {
            axios.get("/api/auth/emails").then(response => {
                response.data.forEach(element => {
                    this.emails.push(element.email)
                });
            });
            this.user.email = this.email;
        },
        mounted () {
            if(Cookies.get('test_cookie') == 'true'){
            }else{
                $('.top_pretlak').addClass('cookie');
            }
        },
        methods: {
            check_email(){
                let hlp = 0;
                this.emails.forEach(element => {
                    if(this.user.email == element){
                        hlp = 1
                    }
                });
                return hlp
            },
            error(){
                var hlp = true;
                const emailRegex = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

                if(!this.user.meno){
                    this.errors.meno = 'Meno je potrebný údaj.'
                    hlp = false;
                }else{
                    this.errors.meno = ''
                }

                if(!this.user.email){
                    this.errors.email = 'Email je potrebný údaj.'
                    hlp = false;
                }else if (!emailRegex.test(this.user.email)) {
                    this.errors.email = 'Zadajte spravný format emailu.'
                    hlp = false
                }else if(this.check_email()){
                    this.errors.email = 'Email už existuje.'
                    hlp = false
                }else{
                    this.errors.email = ''
                }
                    
                if(!this.user.password){
                    this.errors.password = 'Heslo je potrebný údaj.'
                    hlp = false;
                }else if(this.user.password.length < 8){
                    this.errors.password = 'Heslo musí obsahovať viac ako 8 znakov.'
                    hlp = false;
                }else{
                    this.errors.password = ''
                }

                if(!this.passowrd_errors.znaky){
                    hlp = false;
                    $('#heslo').focus();
                }
                else if(!this.passowrd_errors.letter){
                    hlp = false;
                    $('#heslo').focus();
                }
                else if(!this.passowrd_errors.number){
                    hlp = false;
                    $('#heslo').focus();
                }

                if(!this.user.suhlas){
                    this.errors.suhlas = 'Treba udeliť súhlas.'
                    hlp = false;
                }else{
                    this.errors.suhlas = ''
                }
      
                return hlp;
            },
            save(event){
                if(!this.error()){
                    event.preventDefault();
                }else{
                    var name = this.user.meno.split(" ")
                    this.user.meno = name[0]
                    this.user.priezvisko = name[1]
                    localStorage.setItem('premium', 'true');
                    this.$gtm.push({ 
                        event: 'registration',
                        'Event category': 'registration',
                        'Event action': 'successfull_registration',
                        'Event label': 'pretlak'
                    })
                }
                
            }
        },
        watch: {
            'user.email': function() {
                if (this.user.email.length > 0) {
                    $(".input-wrapper.email label").addClass("is-jumped");
                }
            },
            'user.password': function() {
                if(this.focus_password){
                    this.passowrd_errors.znaky = false
                    this.passowrd_errors.number = false
                    this.passowrd_errors.letter = false
                    if((this.user.password).length >= 8){
                        this.passowrd_errors.znaky = true
                    }
                    if(/\d/.test(this.user.password)){
                        this.passowrd_errors.number = true
                    }
                    if(/[A-Z]/.test(this.user.password)){
                        this.passowrd_errors.letter = true
                    }
                    this.errors.password = ''
                }
                if (this.user.password.length > 0) {
                    $(".input-wrapper.password label").addClass("is-jumped");
                }
            }
        },
    }
</script>
<style lang="scss" scoped>
    .password_errors{
        display: flex;
        align-items: center;
        margin-top: 10px;
        span{
            display: flex;
            align-items: flex-start;
            font-size: 14px;
            color: #e83c58;
            margin-right: 20px;
            svg{
                width: 16px;
                height: 13px;
                margin-right: 5px;
            }
        }
        span.active{
            color: #34D399;
        }
    }
    button {
        cursor: pointer;
        color: #fff !important;
    }
    .pretlak{
        display: flex;
        @media only screen and (max-width: 1000px) {
            display: grid;
        }
        .left{
            background: #fff9fb;
            width: 50%;
            padding-left: 100px;
            padding-top: 60px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            @media only screen and (max-width: 1000px) {
                width: 100%;
                order: 2;
                padding: 30px 0 0 0;
            }
            .zlava{
                position: absolute;
                top: 227px;
                right: 18px;
                @media only screen and (max-width: 1000px) {
                    right: 80px;
                }
                @media only screen and (max-width: 500px) {
                    right: 10px;
                    width: 60%;
                    top: 66px;
                }
            }
            .back{
                width: fit-content;
                font-style: normal;
                font-weight: 800;
                font-size: 16px;
                line-height: 20px;
                display: flex;
                align-items: center;
                color: #212541;
                text-decoration: none;
                svg{
                    margin-right: 15px;
                }
                margin-bottom: 60px;
                @media only screen and (max-width: 1200px) {
                    width: 75%;
                    justify-content: center;
                }
                @media only screen and (max-width: 1000px) {
                    display: none;
                }
            }
            img.tablet{
                @media only screen and (max-width: 500px) {
                    width: 100%;
                }
            }
            @media only screen and (max-width: 500px) {
                svg{
                    display: none !important;
                }
            }
            .rect1{
                position: absolute;
                left: 67px;
                bottom: 0;
                top: 0;
                margin: auto;
            }
            .rect2{
                position: absolute;
                left: 0;
                bottom: 0;
                top: 0;
                margin: auto;
            }
            .rect3{
                position: absolute;
                left: 47px;
                bottom: 209px;
                margin: auto;
            }
            .rect4{
                position: absolute;
                right: 67px;
                bottom: 331px;
                margin: auto;
            }
        }
        .right{
            position: relative;
            width: 50%;
            @media only screen and (max-width: 1000px) {
                width: 100%;
                margin-bottom: 20px;
            }
            .rect1{
                position: absolute;
                right: 0;
                bottom: 509px;
                margin: auto;
                @media only screen and (max-width: 1400px) {
                    right: -70px;
                }
            }
            .rect2{
                position: absolute;
                right: 0;
                bottom: 406px;
                margin: auto;
                @media only screen and (max-width: 1400px) {
                    right: -40px;
                }
            }
            .right_cont{
                margin: 0 auto;
                width: 480px;
                @media only screen and (max-width: 1000px) {
                    width: 80%;
                }
                @media only screen and (max-width: 500px) {
                    width: 95%;
                }
                .form-helper{
                    display: flex; 
                    align-items: center;
                    @media only screen and (max-width: 1200px) {
                        padding: 0;
                    }
                    input{    
                        width: 15px;
                        height: 15px;
                        margin-right: 10px;
                        cursor: pointer;
                    }
                    p{
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 20px;
                        color: #ABABAB;
                        margin: 0;
                        cursor: pointer;
                        a{
                            text-decoration: underline;
                            color: #F93C34; 
                        }
                    }
                }
                .p_logo{
                    display: flex;
                    margin-bottom: 90px;
                    justify-content: space-between;
                    width: 360px;
                    margin-top: 56px;
                    @media only screen and (max-width: 1000px) {
                        margin: 30px auto;
                    }
                    @media only screen and (max-width: 500px) {
                        width: 320px;
                        img{
                            width: 120px;
                        }
                    }
                }
                h1{
                    font-style: normal;
                    font-weight: 800;
                    font-size: 40px;
                    line-height: 54px;
                    color: #212541;
                    span{
                        padding-bottom: 3px;
                        border-bottom: #3455DB 4px solid;
                    }
                    @media only screen and (max-width: 1000px) {
                        text-align: center;
                    }
                    @media only screen and (max-width: 500px) {
                        font-size: 30px;
                        line-height: 40px;
                    }
                }
                .back{
                    width: fit-content;
                    font-style: normal;
                    font-weight: 800;
                    font-size: 16px;
                    line-height: 20px;
                    display: none;
                    align-items: center;
                    color: #212541;
                    text-decoration: none;
                    svg{
                        margin-right: 15px;
                    }
                    margin: 40px auto;
                    @media only screen and (max-width: 1000px) {
                        display: flex;
                    }
                }
                p.top_text{
                    margin: 30px 0 50px 0;
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 28px;
                    color: #6B6F8C;
                    @media only screen and (max-width: 1200px) {
                        width: 80%;
                    }
                    @media only screen and (max-width: 1000px) {
                        text-align: center;
                        margin: 30px auto;
                    }
                }
                form{
                    @media only screen and (max-width: 1000px) {
                        margin: 0 auto;
                    }
                }
            }
                
        }
    }
</style>
<style lang="scss">
.graphics-box.graphics-box--02.rellax{
    @media only screen and (max-width: 1000px) {
        display: none !important;
    }
}
</style>